export interface Field<Value> {
  value: Value
  error: string | null
}

export const initField = <Value>(value: Value): Field<Value> => ({ value, error: null })
